<template>
  <div class="act466_container">
    <div class="act466_container-item">
      <div class="act466_container-item-time">
        <div class="timel">倒计时</div>
        <yd-countdown
          class="timer"
          timetype="second"
          :time="d.time"
          v-if="d.time > 0"
        >
          <span v-if="d.time > 86400"><em>{%d0}{%d1}{%d2}</em>天</span>
          <em>{%h1}{%h2}</em>
          <em>{%m1}{%m2}</em>
          <em>{%s1}{%s2}</em>
        </yd-countdown>
        <div style="clear: both"></div>
      </div>
    </div>
    <div class="act466_container-item">
      <div class="act466_container-item-kan">
        <yd-flexbox>
          <yd-flexbox-item
            >已砍<strong class="price">{{ d.bonus }}</strong
            >元</yd-flexbox-item
          >
          <div>
            还差<span class="price">{{ d.discount_price }}</span
            >元
          </div>
        </yd-flexbox>
        <yd-progressbar
          type="line"
          :progress="progress4"
          trail-width="4"
          stroke-color="#1D9190"
          trail-color="#FFFFFF"
        ></yd-progressbar>
        <yd-flexbox>
          <yd-flexbox-item
            ><span class="old-price">原价：9.9元 / 月</span></yd-flexbox-item
          >
          <div>VIP：0元</div>
        </yd-flexbox>
      </div>
      <div class="btn">
          <yd-button
            class="to-copy"
            size="large"
            type="hollow"
            :data-clipboard-text="'￠' + password+'￠'" @click.native="doCopy"
            shape="circle"
            >为好友助力</yd-button
          >
      </div>
      <div class="txt-btn">
        <span>&nbsp;</span>
      </div>
    </div>
    <div class="act466_container-item">
      <div class="act466_container-item-img">
        <img :src="$cdnPath.img + 'Activity/466/hyzl.png'" />
      </div>
      <div class="act466_container-item-zhuli">
        <div v-if="d.record.length == 0" style="text-align: center">
          (⊙o⊙)…还没好友助力呢~
        </div>
        <yd-flexbox
          class="zhuli-item"
          v-for="(p, index) in d.record"
          :key="index"
          v-else
        >
          <yd-flexbox-item>{{ p.name }}</yd-flexbox-item>
          <div>
            助力<span class="price">{{ p.value }}</span
            >元
          </div>
        </yd-flexbox>
      </div>
    </div>
    <div class="act466_container-item">
      <div class="act466_container-item-img">
        <img :src="$cdnPath.img + 'Activity/466/hdgz.png'" />
      </div>
      <div class="act466_container-item-info">
        <p>
          1、跨年砍价活动，通过邀请好友获得金额，最低0元超优惠购买VIP；邀请新用户（未注册下载过的用户）助力金额翻倍
        </p>
        <p>2、活动每周一个周期，每周日晚23：59清零助力记录和金额</p>
        <p>
          3、邀请好友助力，好友也会获得助力金；每个周期内，每位用户助力次数上限5次
        </p>
        <p>
          4、每个周期内，可随时结束活动，使用助力金兑换购买VIP，结束后，当前周期内不可重新发起
        </p>
        <p>
          5、每个周期内，用户首次参与都可获得官方见面礼，见面礼包的金额随机发放
        </p>
        <p>6、每位用户不可给自己助力，不可重复助力相同好友</p>
        <p>
          7、参与活动的用户、助力的用户需真实有效，如果鉴别为非正当手段参与活动，将取消参与资格和助力金额
        </p>
        <p>
          8、由于不可抗拒因素、网络、作弊等非有影官方原因导致活动出现异常情况，有影官方有权采取调整、暂停等措施，如对本活动有任何咨询或疑问，请联系客服微信
          dfacf222
        </p>
        <p>活动时间：2020.12.31 ~ 2021.1.11</p>
      </div>
    </div>
    <yd-popup
      v-model="rstDialog"
      position="center"
      width="80%"
      :close-on-masker="false"
    >
      <div class="rst-container">
        <div class="rst-container-box">
          <div class="rst-container-title">
            <template>有影见面礼</template>
          </div>
          <div class="rst-container-content">
            <template>恭喜获得有影助力金</template>
          </div>
          <div class="rst-container-price">
            <template>2元</template>
          </div>
          <div class="rst-container-footer">
            <div class="btn btn2" :data-clipboard-text="'￠' + password+'￠'" @click="doCopy">开始砍价</div>
          </div>
        </div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import { post, fetch } from "@/api/request";
import API from "@/api/app.conf.js";
import Clipboard from "clipboard";

export default {
  name: "index",
  data() {
    return {
      rstDialog: false,
      password: this.$route.params.ext ? this.$route.params.ext : 0,
      d: {
        is_join: 0,
        is_end: 0,
        record: [],
        time: 0,
        price: 9.9,
        bonus: 0,
        discount_price: 0,
      },
    };
  },
  computed: {
    progress4() {
      return 1 - this.d.discount_price / this.d.price;
    },
  },
  mounted() {
    this.$dialog.loading.open("正在初始化...");
    if (this.password == 0) { return;}
    post(API.U("h5_help_status", "/api/h5/v1/common/"), { password: this.password})
      .then((res) => {
        console.log(res);
        this.$dialog.loading.close();
        if (res.status_code == 200) {
          this.d = JSON.parse(
            decodeURIComponent(res.data.replace(/\+/g, "%20"))
          );
          console.log(this.d);
          if (this.userId == 0) {
            this.rstDialog = !this.d.is_join;
          }
        } else if (res.status_code == 403) {
          this.$dialog.alert({
            mes: "请先登录",
            callback: () => {
              this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 0);
            },
          });
        } else {
          this.$dialog.alert({
            mes: "code:" + res.status_code + "错误" + res.message,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        this.$dialog.alert({
          mes: "网络错误",
        });
        this.$dialog.loading.close();
      });
  },
  methods: {
    doCopy() {
      var clipboard = new Clipboard(".to-copy");
      clipboard.on("success", (e) => {
        clipboard.destroy();
        this.$dialog.alert({ mes: mes });
        // 释放内存
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        // 释放内存
        clipboard.destroy();
      });
      this.$dialog.loading.open('正在打开');
      setTimeout(()=>{
        location.href  = 'yymedias://app/open';
      }, 50);
      setTimeout(()=>{
        this.$dialog.loading.close();
        location.href = 'https://apph5.yymedias.com/appstore';
      }, 1000);
    }
  },
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
.rst-img {
  width: 50px;
}
.rst-container {
  position: relative;
  color: #fff5c9;
  font-size: 0.3rem;
  &-info {
    margin: 0.2rem;
    margin-top: 0.1rem;
    max-height: 5rem;
    overflow: auto;
    text-align: left;
    line-height: 1.5em;
    font-size: 0.8em;
  }

  &-box {
    border: 2px solid #1d9190;
    border-radius: 0.4rem;
    background-color: #c50e10;
    line-height: 1.7em;
    text-align: center;
    img {
      width: 50%;
    }
  }
  &-title {
    font-size: 0.46rem;
    line-height: 1.5em;
    font-weight: bold;
    padding-top: 0.4rem;
  }
  &-content {
    padding-top: 0.2rem;
  }
  &-price {
    font-size: 1.3rem;
    line-height: 2em;
  }
  &-footer {
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      margin: 0.2rem 0.1rem;
      padding: 0.1rem 0.6rem;
      border-radius: 2rem;
      border: 1px solid #fff5c9;
      &.btn2 {
        background-color: #1d9190;
      }
      &.btn2:active {
        background-color: #2e4a41;
      }
      &.btn1:active {
        background-color: #b50b10;
      }
    }
  }
  &-close {
    position: absolute;
    line-height: 1.5em;
  }
}
.act466_container {
  position: relative;
  background-color: #1d9190;
  color: #fff;
  &-item {
    position: relative;
    width: 100%;
    line-height: 1.7em;
    padding: 0 0.4rem;
    &-time {
      padding: 0.8rem 0;
      // border:1px solid red;
      position: relative;
      width: 100%;
      .timel {
        font-size: 0.5rem;
      }
      .timer {
        position: absolute;
        right: 0;
        top: 50%;
        width: 100%;
        transform: translateY(-50%);
        text-align: right;
        em {
          background-color: #16777a;
          margin: 0 0.1rem;
          font-size: 0.5rem;
          padding: 0.1rem;
        }
      }
    }
    &-kan {
      font-size: 0.32rem;
      // border:1px solid red;
      background-color: #16777a;
      padding: 0.3rem 0.2rem;
      line-height: 2em;
      .price {
        font-size: 1.5em;
        padding: 0 0.2rem;
      }
      .old-price {
        text-decoration: line-through;
      }
    }

    .btn {
      font-size: 0.32rem;
      position: relative;
      width: 14em;
      margin: 0 auto;
    }
    .txt-btn {
      font-size: 0.3rem;
      text-align: center;
      padding: 0.4rem;
    }

    &-img {
      padding-top: 1.2rem;
      width: 100%;
      text-align: center;
      img {
        width: 40%;
      }
    }
    &-zhuli {
      padding: 0.6rem 0;
      font-size: 0.3rem;
      .zhuli-item {
        padding: 0.2rem 0;
        border-bottom: 1px solid #fff;
        .price {
          font-size: 1.5em;
          padding: 0 0.2rem;
        }
      }
    }

    &-info {
      padding: 0.2rem 0 1rem 0;
      p {
        padding-top: 0.2rem;
      }
    }
  }
}
</style>